import { useContext, useState } from 'react'
import Layout from 'shared/layouts/Main'
import useInit from './hooks/useInit'
import getRows from './utils/getRows'
import DeleteModal from 'shared/components/DeleteModal'
import { apiUrls, tableColumnWidths, roles } from 'consts'
import {
  PagingState,
  SearchState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  SortingState,
  DataTypeProvider,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  SearchPanel,
  Table,
  TableColumnResizing,
  TableHeaderRow,
  Toolbar,
  PagingPanel,
} from '@devexpress/dx-react-grid-bootstrap4'
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid/dist/dx-react-grid'
import hasAnyRole from 'shared/utils/hasAnyRole'
import getBrandContent from 'utils/getBrandContent'
import SearchPanelInput from 'shared/components/SearchPanelInput'
import Footer from 'shared/components/Footer'
import getPageSize from 'utils/getPageSize'
import { formatDate, stringToDate } from 'utils/dateUtils'
import { ReactReduxContext } from 'react-redux'
import LayoutSwitcher from 'components/LayoutSwitcher'

const Customers: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [rows, setRows] = useState<any>([])
  const [showModal, setShowModal] = useState<boolean>(false)
  const [filter, setFilter] = useState<object | null>(null)
  const [deleteEntryId, setDeleteEntryId] = useState<boolean | number>(false)
  const [filterVisible, setFilterVisible] = useState<boolean>(false)

  const { store } = useContext(ReactReduxContext)

  const columns: { name: string; title: string; encodeHtml?: boolean; getCellValue?: any }[] = [
    { name: 'name', title: 'Name' },
    { name: 'vslz_id', title: 'Visualize ID' },
    { name: 'vslz_password', title: 'Visualize Password' },
    { name: 'ais_security_string', title: 'AIS Security String' },
    { name: 'active', title: 'Active' },
    { name: 'action', title: 'Action', encodeHtml: false },
  ]

  const columnWidths: TableColumnWidthInfo[] = [
    { columnName: 'name', width: 'auto' },
    { columnName: 'vslz_id', width: tableColumnWidths.id },
    { columnName: 'vslz_password', width: 'auto' },
    { columnName: 'ais_security_string', width: 'auto' },
    { columnName: 'active', width: tableColumnWidths.active },
    { columnName: 'action', width: tableColumnWidths.action },
  ]

  useInit({
    setRows,
    setDeleteEntryId,
    setShowModal,
    setShowOverlay,
    filter,
  })

  const TableComponent = ({ ...restProps }) => (
    <Table.Table {...restProps} className='small with-action min-mobile-width' />
  )
  const isAdmin: boolean = hasAnyRole([roles.admin, roles.superAdmin])

  const [dateFormatter] = useState<any>({
    for: ['last_used_date'],
    formatterComponent: (props) => formatDate(stringToDate(props.row.last_used_date)),
    editorComponent: undefined,
    availableFilterOperations: undefined,
  })

  const SearchPanelInputComponent = (props) => {
    return SearchPanelInput({
      addUrl: isAdmin ? '/add-customer' : undefined,
      addText: isAdmin ? 'Add Customer' : undefined,
      inputProps: props,
    })
  }

  const PagingContainer = (props) => {
    return <PagingPanel.Container {...props} className='table-footer' />
  }

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      menuBottomInsert={hasAnyRole([roles.superAdmin]) ? <LayoutSwitcher store={store} /> : false}
    >
      <>
        <Grid rows={rows} columns={columns}>
          <DataTypeProvider {...dateFormatter} />
          <SortingState defaultSorting={[{ columnName: 'name', direction: 'asc' }]} />
          <SearchState defaultValue='' />
          <IntegratedSorting />
          <IntegratedFiltering />
          <PagingState defaultCurrentPage={0} pageSize={getPageSize()} />
          <IntegratedPaging />
          <Toolbar />
          <SearchPanel inputComponent={SearchPanelInputComponent} />
          <Table tableComponent={TableComponent} />
          <TableColumnResizing defaultColumnWidths={columnWidths} resizingMode='nextColumn' />
          <TableHeaderRow showSortingControls />
          <PagingPanel pageSizes={[]} containerComponent={PagingContainer} />
        </Grid>

        <DeleteModal
          url={apiUrls.customers}
          showModal={showModal}
          setShowModal={setShowModal}
          deleteEntryId={deleteEntryId}
          setDeleteEntryId={setDeleteEntryId}
          entityName='Customer'
          getRows={getRows}
          setRows={setRows}
        />
      </>
    </Layout>
  )
}

export default Customers
